export default __webpack_public_path__ + "static/media/phone.4a00f59d.svg";